import React from "react";
import { RxCross2 } from "react-icons/rx";

export default function TutorialVideoModal({ closeTutorialModal, videoLink }) {
  return (
    <main className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-10 backdrop-blur-sm z-50">
      <main className="bg-white rounded shadow-lg flex flex-col items-start justify-center gap-1">
        <header className="bg-gray-50 p-1 flex items-center justify-between w-full font-semibold rounded">
          <img
            src={`/graph_img/viztaLogoAllBlue.png`}
            width={"100"}
          />
          <RxCross2
            onClick={closeTutorialModal}
            className="cursor-pointer text-black"
          />
        </header>
        <section className="p-2">
          <iframe
            width="1060"
            height="515"
            src="https://www.youtube.com/embed/Z61iYHLt5Tk?si=EuOIgvYtxHxGAnrq"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </section>
      </main>
    </main>
  );
}
